import React, { forwardRef, Fragment } from "react";
import Tooltip, { TooltipProps } from "@mui/material/Tooltip";

import AppText from '@/components/AppText'

interface AppTooltipProps extends Omit<TooltipProps, "title"> {
  title: string;
}

const AppTooltip = forwardRef<HTMLDivElement, AppTooltipProps>(
  ({ title, children, placement = 'bottom', ...props }, ref) => {
    return (
      <Tooltip
        enterTouchDelay={0}
        title={
          <Fragment>
            <AppText color="white" variant="xs">{title}</AppText>
          </Fragment>
        }
        placement={placement}
        {...props}
      >
        <div ref={ref}>{children}</div>
      </Tooltip>
    );
  }
);

AppTooltip.displayName = "AppTooltip";

export default AppTooltip;